module.exports = __webpack_public_path__ + "media/images/icons/twotone/fire-27f549895ba2ef47ea2fd2cedd2a9247.svg";